import ListPage, { TListPage } from 'components/ListPage';
import * as baseConfig from 'schemas/event';

const EventList = (props: Partial<TListPage>) => {
  return <ListPage entityName="event" {...baseConfig} {...props} isExportAllowed />;
};

export default EventList;
